export const ArrowUpRight12 = ({
  strokeWidth = "1.4",
}: {
  strokeWidth?: string;
}) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5113_23214)">
      <path
        d="M3 9L9 3"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.125 3H9V7.875"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5113_23214">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
